import { EDevice } from './enums';

export const deviceByBreakpoint = (size: string): EDevice => {
  switch(size) {
    case 'xs' || 'sm':
      return EDevice.mobile;
    default:
      return EDevice.desktop;
  }
};